/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'upload-hsm-packages-page';
const componentName = 'upload-hsm-packages-page';
const prefix = `${moduleName}.${componentName}`;

export const headerLabel = `${prefix}.headerLabel`;
export const uploadHsmPackageLabel = `${prefix}.uploadHsmPackageLabel`;
export const uploadHsmPackageHelperText = `${prefix}.uploadHsmPackageHelperText`;

export const ENGLISH = {
    [headerLabel]: 'HSM Packages',
    [uploadHsmPackageLabel]: 'Upload HSM Package',
    [uploadHsmPackageHelperText]: 'Supported file: safenet.tar',
};
